import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 续签待办列表-lx，wy
export const queryContractRenewalByUserCode = (data) => {
    return request({
        url: apiCrmHost + '/queryContractRenewalByUserCode',
        method: 'post',
        data
    });
};
// 续签待办-保存 -lx，wy
export const saveRenewal = (data) => {
    return request({
        url: apiCrmHost + '/contract/renewal/registration/v2/save',
        method: 'post',
        data
    });
};
// 续签待办合同分公司统计 -lx,wy
export const getContractRenewalStatisticsByCompany = (data) => {
    return request({
        url: apiCrmHost + '/todo/contractRenewalStatisticsByCompany',
        method: 'post',
        data
    });
};
// 续签待办合同分公司统计明细查询 -lx,wy
export const getContractRenewalStatisticsByCompanyDetail = (data) => {
    return request({
        url: apiCrmHost + '/todo/contractRenewalStatisticsByCompanyDetail',
        method: 'post',
        data
    });
};
// 续签待办合同行业统计 -lx,wy
export const getContractRenewalStatisticsByIndustry = (data) => {
    return request({
        url: apiCrmHost + '/todo/contractRenewalStatisticsByIndustry',
        method: 'post',
        data
    });
};
// 续签待办合同行业统计明细查询 -lx,wy
export const getContractRenewalStatisticsByIndustryDetail = (data) => {
    return request({
        url: apiCrmHost + '/todo/contractRenewalStatisticsByIndustryDetail',
        method: 'post',
        data
    });
};
// 续签待办合同个人统计 -lx,wy
export const getContractRenewalStatisticsByUser = (data) => {
    return request({
        url: apiCrmHost + '/todo/contractRenewalStatisticsByUser',
        method: 'post',
        data
    });
};
// 续签待办合同个人统计明细查询 -lx,wy
export const getContractRenewalStatisticsByUserDetail = (data) => {
    return request({
        url: apiCrmHost + '/todo/contractRenewalStatisticsByUserDetail',
        method: 'post',
        data
    });
};
// 续签待办统计导出 -lx,wy
export const exportContractRenewalStatistics = (data) => {
    return request({
        url: apiCrmHost + '/todo/exportContractRenewalStatistics',
        method: 'post',
        data
    });
};

// 续签修改跟进人列表
export const getToDoPage = (data) => {
    return request({
        url: apiCrmHost + '/todo/page',
        method: 'post',
        data
    });
};

// 续签修改跟进人
export const updateToDo = (data) => {
    return request({
        url: apiCrmHost + '/todo/update',
        method: 'post',
        data
    });
};
